export const getCookie = key => {
    let cookie = '';

    const value = '; ' + document.cookie;
    const parts = value.split('; ' + key + '=');
    if (parts.length == 2) {
        cookie = parts
            .pop()
            .split(';')
            .shift();
    }

    return cookie ? cookie : null;
};

export const setCookie = (key, value, expirationDays) => {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expiresIn = 'expires=' + expirationDate.toUTCString();

    document.cookie = key + '=' + value + ';' + expiresIn + ';path=/';
};

export const removeCookie = key => {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';

    if (document.cookie != '') {
        document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + window;
        location.hostname + '; path=/;';
    }

    if (document.cookie != '') {
        document.cookie = key + '=; max-age=0; path=/;';
    }

    if (document.cookie != '') {
        document.cookie = key + '=; max-age=0; domain=' + window;
        location.hostname + '; path=/;';
    }
};
